import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();

  const navState = useMemo(() => ({ from: location.pathname }), [location.pathname]);

  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <div data-testid="auth-loading" className="text-slate-500 font-manrope text-sm">Loading…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" state={navState} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
